import React, { Component } from "react";

export default class LanguageVersionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Initialize with initialData if editing, or defaults if adding
      languageCode: props.isEditMode ? props.initialData.languageCode : "da",
      title: props.isEditMode ? props.initialData.title : "",
      category: props.isEditMode ? props.initialData.category : "",
      status: props.isEditMode ? props.initialData.status : "ACTIVE",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    // The parent component (ConceptualQuestionManager or LanguageVersionDisplay)
    // will add commonQuestionId if needed before calling the top-level API handler.
    this.props.onSubmit({ ...this.state });
  }

  render() {
    const { isEditMode, onCancel } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="field">
          <label className="label" htmlFor="form-languageCode">
            Language Code
          </label>
          <div className="control">
            <input
              id="form-languageCode"
              className="input"
              type="text"
              name="languageCode"
              placeholder="e.g., EN, DA"
              required
              maxLength="5"
              value={this.state.languageCode}
              onChange={this.handleInputChange}
              readOnly={isEditMode} // Language code should not be changed when editing
            />
          </div>
          {isEditMode && (
            <p className="help is-info">
              Language code cannot be changed after creation.
            </p>
          )}
        </div>

        <div className="field">
          <label className="label" htmlFor="form-title">
            Title
          </label>
          <div className="control">
            <input
              id="form-title"
              className="input"
              type="text"
              name="title"
              placeholder="Title for this language"
              required
              value={this.state.title}
              onChange={this.handleInputChange}
            />
          </div>
        </div>

        <div className="field">
          <label className="label" htmlFor="form-category">
            Category
          </label>
          <div className="control">
            <input
              id="form-category"
              className="input"
              type="text"
              name="category"
              placeholder="Category for this language"
              required
              value={this.state.category}
              onChange={this.handleInputChange}
            />
          </div>
        </div>

        <div className="field">
          <label className="label" htmlFor="form-status">
            Status
          </label>
          <div className="control">
            <div className="select is-fullwidth">
              <select
                id="form-status"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
              >
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <div className="buttons mt-4">
          <button type="submit" className="button is-primary">
            {isEditMode ? "Save Changes" : "Add This Version"}
          </button>
          {onCancel && (
            <button type="button" onClick={onCancel} className="button">
              Cancel
            </button>
          )}
        </div>
      </form>
    );
  }
}
